import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { Slot } from '@radix-ui/react-slot';
import { type NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import React from 'react';
import SvgDelete from '../../../../__generated__/icon/SvgDelete';
import { extractMaxWidthValue } from '../_utils/extractMaxWidthValue';
export const ImageNodeView = t0 => {
  const $ = _c(28);
  const {
    node,
    editor,
    getPos,
    selected
  } = t0;
  const isEditable = editor.isEditable;
  const src = node.attrs.src;
  const href = node.attrs.href;
  const className = node.attrs?.class;
  const styleText = node.attrs?.style ?? "";
  let t1;
  if ($[0] !== styleText) {
    t1 = extractMaxWidthValue(styleText);
    $[0] = styleText;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const width = t1;
  let t2;
  if ($[2] !== editor || $[3] !== getPos || $[4] !== node.nodeSize) {
    t2 = e => {
      e.stopPropagation();
      const from = getPos();
      const to = from + node.nodeSize;
      editor.chain().deleteRange({
        from,
        to
      }).run();
    };
    $[2] = editor;
    $[3] = getPos;
    $[4] = node.nodeSize;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleDeleteClick = t2;
  let t3;
  if ($[6] !== className) {
    t3 = cn("w-full", className);
    $[6] = className;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = width ?? undefined;
  let t5;
  if ($[8] !== t4) {
    t5 = {
      maxWidth: t4
    };
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== src || $[11] !== t3 || $[12] !== t5) {
    t6 = <img alt="editor-img" className={t3} draggable={false} loading="lazy" src={src} style={t5} />;
    $[10] = src;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const image = t6;
  let t7;
  if ($[14] !== isEditable || $[15] !== selected) {
    t7 = cn("relative", {
      "ring-2 ring-B-500 ring-offset-2": selected,
      "cursor-pointer": isEditable
    });
    $[14] = isEditable;
    $[15] = selected;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== handleDeleteClick || $[18] !== isEditable) {
    t8 = isEditable ? <button className="absolute right-12 top-12 flex size-28 items-center justify-center rounded-pill bg-Gray-black opacity-50" type="button" onClick={handleDeleteClick}><SvgDelete className="text-Gray-white" name="X" /></button> : null;
    $[17] = handleDeleteClick;
    $[18] = isEditable;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== href || $[21] !== image || $[22] !== isEditable) {
    t9 = href ? <a className="block cursor-pointer" href={href} rel="noopener noreferrer" target="_blank" onClick={e_0 => isEditable && e_0.preventDefault()}>{image}</a> : image;
    $[20] = href;
    $[21] = image;
    $[22] = isEditable;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t10 = <Slot className="relative w-full"><NodeViewWrapper as="div" className={t7}>{t8}{t9}</NodeViewWrapper></Slot>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};